import { Injectable } from '@angular/core';
import { IServiceToolbarBase, PagedBaseResponse } from 'rte-library';
import { Entity } from './entity.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Provider } from '../provider/provider.model';
import { appendHttpParams } from '../../helpers/http.helper';
import { ObjectValue } from '../../models/object-value.model';
import { EntityTypeEnum } from '../../enums/entity-type.enum';

@Injectable({
  providedIn: 'root'
})
export class EntityService implements IServiceToolbarBase<Entity> {

  constructor(private http: HttpClient) {
  }

  clear(objectCurrent: Entity) {
    objectCurrent.Id = null;
    objectCurrent.Provider = new Provider();
    objectCurrent.Description = null;
    objectCurrent.EntityType = EntityTypeEnum.Entity;
    objectCurrent.Query = '';
  }

  save(objectCurrent: Entity) {

    if (objectCurrent.Id <= 0  || objectCurrent.Id == null) {
      delete objectCurrent.Id;
      delete objectCurrent.Revision;
      return this.http.post(environment.apiUrl + 'api/entities', objectCurrent);
    } else {
      objectCurrent.Revision = !objectCurrent.Revision ? 1 : objectCurrent.Revision;
      return this.http.put(environment.apiUrl + 'api/entities', objectCurrent);
    }
  }

  delete(objectCurrent: Entity): Observable<boolean> {

    const params = new HttpParams()
                    .set('id', objectCurrent.Id.toString());

    return this.http.delete<boolean>(environment.apiUrl + 'api/entities', {params});
  }

  get(objectCurrent: Entity, page: number, pageSize: number): Observable<PagedBaseResponse<Entity>> {
    page++;
    return this.getByAmount(objectCurrent, page, pageSize);
  }

  getByAmount(objectCurrent: Entity, page: number, amountByPage: number): Observable<PagedBaseResponse<Entity>> {
    let params = new HttpParams()
                    .set('Page', page.toString())
                    .set('AmountByPage', amountByPage.toString());

    if (objectCurrent) {
      params = appendHttpParams('Id', objectCurrent.Id, params);
      params = appendHttpParams('Description', objectCurrent.Description, params);
      params = appendHttpParams('EntityType', objectCurrent.EntityType, params);
      if (objectCurrent.Provider) {
        params = appendHttpParams('ProviderId', objectCurrent.Provider.Id, params);
      }
    }

    return this.http.get<PagedBaseResponse<Entity>>(environment.apiUrl + 'api/entities/search', {params});
  }

  getEntityTypeOptions(): ObjectValue[] {
    return [
      new ObjectValue('Entidade', EntityTypeEnum.Entity),
      new ObjectValue('Lista', EntityTypeEnum.List)
    ];
  }
}
